import { FC, useEffect, useState } from 'react';
import { ApplicationsDropdownMenu, useSideMenu } from '../../../components';
import { ApplicationMenuWrapperProps } from './ApplicationsDropdownWrapper.types';
import { ApplicationsDropdownItems } from './ApplicationsDropdownItems';

export const ApplicationsDropdownWrapper: FC<ApplicationMenuWrapperProps> = ({ trigger, placement, ...props }) => {
  const { isSideMenuOpen } = useSideMenu();

  const [isOpened, setIsOpened] = useState(false);

  const forceCloseWhenSideMenuClosed = (isSideMenuOpen: boolean) => !isSideMenuOpen && setIsOpened(false);

  useEffect(() => {
    forceCloseWhenSideMenuClosed(isSideMenuOpen);
  }, [isSideMenuOpen]);

  return (
    <ApplicationsDropdownMenu
      trigger={trigger}
      placement={placement}
      items={<ApplicationsDropdownItems />}
      isOpened={isOpened}
      onOpenedChange={setIsOpened}
      {...props}
    />
  );
};
